import { useCreateDialogLookModal } from 'components/create-dialog/CreateDialogModalFrame';
import { PlusIcon } from 'components/icons';
import { Button } from 'components/ui/button';
import { ReactNode, useCallback } from 'react';
import { ClassifierData } from 'types/classifiers';
import { InvoiceData, InvoiceRowForm } from 'types/invoices';
import { InvoiceRowEditModal } from './InvoiceRowEditModal';
import { totalsButtonStyle } from '../TotalsTableCard';

const FORM_OVERFLOW_CUSTOM_STYLE = {
    display: 'grid',
    gridTemplateRows: 'auto 1fr auto',
    width: '700px',
};

interface Props {
    children: ReactNode;
    handleSubmit: (data: InvoiceRowForm) => void;
    classifiers: Record<string, ClassifierData>;
    invoice: InvoiceData;
    matterId: number;
}

const useInvoiceRowAddModal = (
    invoice: InvoiceData,
    matterId: number,
    handleSubmit: (data: InvoiceRowForm) => void
) => {
    const { openModal, closeModal } = useCreateDialogLookModal();

    const openAddRowModal = useCallback(() => {
        openModal(
            <InvoiceRowEditModal
                onClose={closeModal}
                action={'create'}
                invoice={invoice}
                initialData={{
                    invoiceRowId: 0,
                    matterId: matterId,
                    description: '',
                    itemTotal: 0,
                    discountRate: 0,
                    discountAmount: '0',
                    amountBeforeDiscount: 0,
                }}
                onSubmit={handleSubmit}
            />,
            closeModal,
            FORM_OVERFLOW_CUSTOM_STYLE
        );
    }, [closeModal, handleSubmit, matterId, openModal, invoice]);

    return { openAddRowModal };
};

export const InvoiceRowAddButton = (props: Props) => {
    const { handleSubmit, invoice, matterId, children } = props;
    const { openAddRowModal } = useInvoiceRowAddModal(invoice, matterId, handleSubmit);

    return (
        <Button {...totalsButtonStyle('w-[125px]')} onClick={openAddRowModal}>
            {/* Classic's label carries its own "+". */}
            <PlusIcon aria-hidden className="new:block hidden size-3.5" />
            {children}
        </Button>
    );
};
